import {
  MantineProvider as MMantineProvider,
  type MantineProviderProps,
} from '@mantine/core';
import type { PropsWithChildren } from 'react';
import { theme as defaultTheme, resolver } from './theme';

// mantine styles
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/tiptap/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/spotlight/styles.css';
import '@mantine/dropzone/styles.css';

export function MantineProvider({
  children,
  ...props
}: PropsWithChildren<MantineProviderProps>) {
  return (
    <MMantineProvider
      theme={defaultTheme}
      cssVariablesResolver={resolver}
      {...props}
    >
      {children}
    </MMantineProvider>
  );
}
